import {Modal} from 'bootstrap';
import {Component, Input, OnInit, EventEmitter, Output, ViewChild, ElementRef, OnDestroy} from '@angular/core';

@Component({
  selector: 'app-modal-new-account',
  templateUrl: './modal-new-account.component.html',
  styleUrls: ['./modal-new-account.component.css'],
  standalone: false
})
export class ModalNewAccountComponent implements OnInit, OnDestroy {
  @ViewChild('closeButton') closeButton: ElementRef;

  @Input() vm: any;
  @Output() saveNewAccountEmit = new EventEmitter<string>();

  constructor() { }

  ngOnInit() {
  }

  saveNewAccount(){
    this.saveNewAccountEmit.emit();
  }

  ngOnDestroy() {
    const modalEl = this.closeButton?.nativeElement?.closest('.modal');
    if (modalEl) {
      const modal = Modal.getInstance(modalEl);
      if (modal) {
        modal.hide();
      }
    }
  }

}
